"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROJECT_ACTION = exports.PROJECT_COLLECTION_ACTION = void 0;
// collection actions
exports.PROJECT_COLLECTION_ACTION = {
    CREATE: 'create',
};
// resource actions
exports.PROJECT_ACTION = {
    UPDATE: 'update',
    DELETE: 'delete',
};
